import ClockIcon from '@/common/assets/icons/clockIcon.svg?react';
import CloseCircleIcon from '@/common/assets/icons/closeCircleIcon.svg?react';
import Input from '@/common/components/base/input/base/Input';
import TimePickerModal from '@/common/components/base/input/timeInput/modals/TimePickerModal';
import { TimeInputType } from '@/common/components/base/input/timeInput/TimeInput.type';
import useModal from '@/common/hooks/useModal';
import { useController, useFormContext } from 'react-hook-form';
import { token } from 'styled-system/tokens';

const TimeInput = ({
  name,
  rules,
  label,
  defaultValue = '',
  modalLabel,
  buttonText,
}: TimeInputType) => {
  const { control } = useFormContext();
  const controller = useController({
    rules,
    control,
    name,
    defaultValue,
  });
  const { field, fieldState } = controller;
  const { openModal, open, closeModal } = useModal();
  const errorMessage = fieldState.error?.message;

  const resetTimePicker = () => {
    field.onChange('');
  };

  return (
    <>
      <Input
        inputProps={{
          readOnly: true,
          value: field.value,
          onClick: openModal,
          placeholder: 'دقیقه : ساعت',
        }}
        inputRef={field.ref}
        errorMessage={errorMessage}
        label={label}
        endAttachments={[
          {
            element: field.value ? (
              <CloseCircleIcon
                width="22px"
                stroke={token('colors.black-4')}
                onClick={resetTimePicker}
              />
            ) : (
              <ClockIcon width="22px" stroke={token('colors.black-4')} />
            ),
            shouldRender: true,
            size: 'small',
          },
        ]}
      />
      <TimePickerModal
        open={open}
        buttonText={buttonText}
        onClose={closeModal}
        onSubmit={(value) => field.onChange(value)}
        initialValue={field.value}
        modalLabel={modalLabel}
      />
    </>
  );
};

export default TimeInput;
